import { LISTING, OFFERS } from '../routes';

export const incompleteStatus = {
  color: 'red',
  label: 'Incompleto',
  actions: [
    {
      label: 'Continuar anúncio',
      className: 'btn_qa_completar',
      incomplete: true
    }
  ]
};

export const waitingPaymentStatus = {
  color: 'yellow',
  label: 'Aguardando Pagamento',
  actions: [
    {
      label: 'Pagar Agora',
      className: 'btn_qa_pagar',
      payNow: true
    }
  ]
};

export const listingStatus = [
  {
    statusIds: [1],
    color: 'green',
    label: 'Publicado',
    isPublished: true,
    actions: [
      {
        label: 'Ver Propostas',
        className: 'btn_qa_propostas',
        redirect: `${OFFERS}/#id`
      },
      {
        label: 'Gerenciar Anúncio',
        className: 'btn_qa_editar',
        redirect: `${LISTING}/#id`
      }
    ],
    renewableActions: [
      {
        label: 'Ver Propostas',
        className: 'btn_qa_propostas',
        redirect: `${OFFERS}/#id`
      },
      {
        label: 'Republicar Anúncio',
        className: 'btn_qa_republicar',
        republish: true
      }
    ]
  },
  {
    statusIds: [0],
    ...waitingPaymentStatus
  },
  {
    statusIds: [2, 3, 4, 5, 6],
    color: 'gray',
    label: 'Inativo',
    actions: [
      {
        label: 'Ver Resumo',
        className: 'btn_qa_resumo',
        redirect: `${LISTING}/#id`
      }
    ]
  },
  {
    statusIds: [9],
    color: 'gray',
    label: 'Inativo',
    actions: [
      {
        label: 'Republicar Anúncio',
        className: 'btn_qa_republicar',
        republish: true
      }
    ]
  },
  {
    statusIds: [7, 8, 10],
    color: 'blue',
    label: 'Em Análise',
    disclaimer:
      'Os dados do seu anúncio estão em análise e o prazo para validação é de até 01 (um) dia útil. Fique tranquilo (a), pois você não perderá nenhum dia do plano contratado.',
    actions: [
      {
        label: 'Ver Resumo',
        className: 'btn_qa_resumo',
        redirect: `${LISTING}/#id`
      }
    ]
  }
];

export const getStatus = listing => {
  if (!listing) {
    return null;
  }

  const { canRenew, statusId, incomplete, payNow, renewable } = listing;

  if (incomplete) {
    return incompleteStatus;
  }

  if (payNow) {
    return waitingPaymentStatus;
  }

  const status = (() => {
    const foundStatus = listingStatus.find(
      elem => elem.statusIds.filter(id => id === statusId).length
    );

    if (foundStatus?.renewableActions) {
      if (renewable && canRenew) {
        return {
          ...foundStatus,
          actions: foundStatus.renewableActions,
          renewableActions: undefined
        };
      }
    }

    return foundStatus;
  })();

  return status;
};
